import { render, staticRenderFns } from "./MiniKaskoCarTypeField.vue?vue&type=template&id=70f50d2a&scoped=true&"
import script from "./MiniKaskoCarTypeField.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoCarTypeField.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoCarTypeField.vue?vue&type=style&index=0&id=70f50d2a&lang=scss&scoped=true&"
import style1 from "./MiniKaskoCarTypeField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f50d2a",
  null
  
)

export default component.exports